/* Olyra TrueDetect - comportement partage des sections olyra-td-*.
   Tout est rattache par attributs data-olyra-td-* ; rien ne depend de la position d'une section.
   Les sections se re-initialisent sur shopify:section:load (editeur de theme). */
(function () {
  'use strict';
  if (window.__olyraTd) return;
  window.__olyraTd = true;

  var ready = new WeakSet();

  /* 1. Accordeons, cartes "research" et visionneuses PDF : un seul ecouteur delegue. */
  document.addEventListener('click', function (event) {
    var btn = event.target.closest('[data-olyra-td-toggle]');
    if (!btn) return;
    var panel = document.getElementById(btn.getAttribute('aria-controls'));
    var open = btn.getAttribute('aria-expanded') === 'true';
    var kind = btn.getAttribute('data-olyra-td-toggle');
    btn.setAttribute('aria-expanded', String(!open));
    if (panel) panel.classList.toggle('is-open', !open);

    if (kind === 'card') {
      var card = btn.closest('.olyra-td-rcard');
      if (card) card.classList.toggle('is-open', !open);
    }
    if (kind === 'doc' && panel) {
      var label = btn.querySelector('[data-olyra-td-toggle-label]');
      if (label) label.textContent = open ? btn.dataset.labelOpen : btn.dataset.labelClose;
      var frame = panel.querySelector('.olyra-td-doc__frame');
      if (open || !frame || frame.dataset.loaded) return;
      var src = btn.dataset.docSrc;
      var obj = document.createElement('object');
      obj.type = 'application/pdf';
      obj.data = src + '#view=FitH';
      obj.setAttribute('aria-label', btn.dataset.labelOpen || 'PDF');
      var alt = document.createElement('div');
      alt.className = 'olyra-td-doc__noinline';
      alt.appendChild(document.createTextNode(btn.dataset.labelFallback || ''));
      alt.appendChild(document.createElement('br'));
      var link = document.createElement('a');
      link.href = src;
      link.target = '_blank';
      link.rel = 'noopener';
      link.textContent = btn.dataset.labelFallbackLink || '';
      alt.appendChild(link);
      obj.appendChild(alt);
      frame.appendChild(obj);
      frame.dataset.loaded = '1';
    }
  });

  /* 2. Barre d'achat collante : apparait quand le premier CTA est sorti par le haut,
        se cache tant que le bloc d'achat est a l'ecran. */
  var stickyObservers = [];
  function initSticky() {
    stickyObservers.forEach(function (o) { o.disconnect(); });
    stickyObservers = [];
    var sticky = document.querySelector('[data-olyra-td-sticky]');
    var firstCta = document.querySelector('[data-olyra-td-primary-cta]');
    var offer = document.querySelector('[data-olyra-td-offer]');
    if (!sticky || !firstCta || !offer || !('IntersectionObserver' in window)) return;
    var passedCta = false, inOffer = false;
    function sync() {
      var show = passedCta && !inOffer;
      sticky.classList.toggle('is-visible', show);
      sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
    }
    var a = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        passedCta = !e.isIntersecting && e.boundingClientRect.top < 0;
        sync();
      });
    }, { threshold: 0 });
    a.observe(firstCta);
    var b = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { inOffer = e.isIntersecting; sync(); });
    }, { threshold: 0.08 });
    b.observe(offer);
    stickyObservers.push(a, b);
  }

  document.addEventListener('click', function (event) {
    var btn = event.target.closest('[data-olyra-td-sticky-button]');
    if (!btn) return;
    var bar = btn.closest('[data-olyra-td-sticky]');
    var buy = document.querySelector('[data-olyra-td-buy-button]');
    if (bar && bar.dataset.action === 'buy' && buy) {
      event.preventDefault();
      buy.click();
    }
  });

  /* 3. Rail des etapes : temoin de defilement visible pendant le balayage. */
  function initSteps(root) {
    root.querySelectorAll('[data-olyra-td-steps]').forEach(function (rail) {
      if (ready.has(rail)) return;
      var bar = rail.parentElement.querySelector('[data-olyra-td-steps-bar]');
      if (!bar) return;
      ready.add(rail);
      var thumb = bar.firstElementChild;
      var hideTimer;
      function paint() {
        var max = rail.scrollWidth - rail.clientWidth;
        if (max <= 1) { bar.style.visibility = 'hidden'; return; }
        bar.style.visibility = '';
        var w = Math.max((rail.clientWidth / rail.scrollWidth) * 100, 18);
        thumb.style.width = w + '%';
        thumb.style.marginLeft = ((rail.scrollLeft / max) * (100 - w)) + '%';
      }
      rail.addEventListener('scroll', function () {
        paint();
        bar.classList.add('is-active');
        clearTimeout(hideTimer);
        hideTimer = setTimeout(function () { bar.classList.remove('is-active'); }, 900);
      }, { passive: true });
      rail.addEventListener('pointerleave', function () {
        clearTimeout(hideTimer);
        bar.classList.remove('is-active');
      });
      window.addEventListener('resize', paint, { passive: true });
      paint();
    });
  }

  /* 4. Galerie du bloc d'achat : scroll-snap natif + rail de vignettes. */
  function initSliders(root) {
    root.querySelectorAll('[data-olyra-td-slider]').forEach(function (slider) {
      if (ready.has(slider)) return;
      var track = slider.querySelector('[data-olyra-td-track]');
      var thumbsEl = slider.querySelector('[data-olyra-td-thumbs]');
      if (!track) return;
      ready.add(slider);
      var slides = Array.prototype.slice.call(track.children);
      var nav = [];
      var index = 0;
      function paint() {
        nav.forEach(function (el, i) {
          if (i === index) el.setAttribute('aria-current', 'true');
          else el.removeAttribute('aria-current');
        });
      }
      function go(i) {
        index = Math.max(0, Math.min(slides.length - 1, i));
        track.scrollTo({ left: slides[index].offsetLeft - track.offsetLeft, behavior: 'smooth' });
        paint();
      }
      if (thumbsEl) {
        thumbsEl.textContent = '';
        slides.forEach(function (slide, i) {
          var img = slide.querySelector('img');
          if (!img) return;
          var b = document.createElement('button');
          b.type = 'button';
          b.className = 'olyra-td-slider__thumb';
          b.setAttribute('aria-label', (thumbsEl.dataset.label || '') + ' ' + (i + 1));
          var t = document.createElement('img');
          t.src = slide.dataset.thumb || img.currentSrc || img.src;
          t.alt = '';
          t.width = 56;
          t.height = 56;
          t.loading = 'lazy';
          b.appendChild(t);
          b.addEventListener('click', function () { go(i); });
          thumbsEl.appendChild(b);
          nav.push(b);
        });
      }
      var timer;
      track.addEventListener('scroll', function () {
        clearTimeout(timer);
        timer = setTimeout(function () {
          var mid = track.scrollLeft + track.clientWidth / 2;
          var best = 0, bestDist = Infinity;
          slides.forEach(function (sl, i) {
            var c = sl.offsetLeft - track.offsetLeft + sl.clientWidth / 2;
            var d = Math.abs(c - mid);
            if (d < bestDist) { bestDist = d; best = i; }
          });
          index = best;
          paint();
        }, 90);
      }, { passive: true });
      paint();
    });
  }

  /* 5. Achat : l'envoi du formulaire produit ajoute le pack choisi (Moon Bundle ecrit la quantite dans le formulaire)
        puis va au paiement, comme la page d'origine. Si l'option est desactivee, ou si l'ajout echoue,
        le formulaire s'envoie normalement (ajout puis panier). */
  document.addEventListener('submit', function (event) {
    var form = event.target.closest('[data-olyra-td-buy]');
    if (!form || form.dataset.checkout !== 'true' || form.dataset.native === '1') return;
    event.preventDefault();
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var btn = form.querySelector('[data-olyra-td-buy-button]');
    var label = btn && btn.querySelector('[data-olyra-td-buy-label]');
    var original = label ? label.textContent : '';
    if (btn) {
      if (btn.disabled) return;
      btn.disabled = true;
      if (label && btn.dataset.labelBusy) label.textContent = btn.dataset.labelBusy;
    }
    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: new FormData(form)
    })
      .then(function (res) {
        if (!res.ok) throw new Error('cart/add ' + res.status);
        return res.json();
      })
      .then(function () { window.location.href = root + 'checkout'; })
      .catch(function () {
        if (btn) { btn.disabled = false; if (label) label.textContent = original; }
        form.dataset.native = '1';
        form.submit();
      });
  });

  function init(root) {
    initSteps(root);
    initSliders(root);
    initSticky();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
  document.addEventListener('shopify:section:unload', function () { setTimeout(initSticky, 0); });
})();
